module.exports = __webpack_public_path__ + "static/c3-df47a9a0dc49e7c77e5b6880516a86b4.jpg";